// extracted by mini-css-extract-plugin
export default {"termsText":"styles_termsText__e0+U6","termsLink":"styles_termsLink__eyPHn"};